var PROJ = (typeof PROJ === 'object') ? PROJ : {};
var shipPs = "spc1";
var shipLocalPrice;
document.addEventListener('DOMContentLoaded', function() {
    PROJ.ajaxcart.init();
});



PROJ.ajaxcart = {
    VAR: {},

    init: function () {
        var _this = this;

        var walletElement = document.querySelector('[wallet-configs]');
        if (walletElement) {
            var quickpay = JSON.parse(walletElement.getAttribute('wallet-configs'));
            var miniCart = document.getElementById('mini-cart');
            if (miniCart && Array.isArray(quickpay)) {
                for (var s = 0; s < quickpay.length; s++) {
                    miniCart.classList.add(quickpay[s].name);
                }
            }
        }

        if(sessionStorage.getItem(shipPs) == null)
        {
            sessionStorage.setItem(shipPs,shipProdAuto);
        }
        _this.updateShippingProection();


        setTimeout(function(){
            _this.reloadOfferbar();
            _this.animateCart();
        },100);

        //auto open minicart
        if (window.location.href.includes("minicart=true")) {
            document.documentElement.classList.add('mini-cart');
            document.body.classList.add('mini-cart');

            setTimeout(() => {
                document.documentElement.classList.add('mini-cart-ani');
                document.body.classList.add('mini-cart-ani');
            }, 500);
        }



        ['click'].forEach(eventType => {
            document.body.addEventListener(eventType, function(e) {
                let clicked = e.target;
                if (e.target.closest('a.mini_cart, .opencart, [href="/cart"]')) {
                    e.preventDefault();
                    e.stopPropagation();
                    _this.opencart();
                }
                if (e.target.closest('.nav-close-cart, .minicart-back')) {
                    e.preventDefault();
                    e.stopPropagation();
                    _this.closecart();
                }
                //remove from cart
                if (e.target.classList.contains('remove') && e.target.closest('.incart')) {
                    e.preventDefault();
                    let par = e.target.closest('.incart');
                    let qty = 0;
                    _this.updateItem(par.getAttribute('data-proid'), qty);
                }

                //Hide Complet the set
                if (e.target.classList.contains('hide-cts')) {
                    e.preventDefault();
                    document.body.classList.add('hide-cts-cart');
                }
                if (clicked.classList.contains('qty-step-btn')) {
                    e.preventDefault();
                    let input = clicked.closest('.mcart-item').querySelector('.qty-input');
                    if (input) {
                        let currentValue = parseInt(input.value, 10) || 0;

                        if (clicked.classList.contains('plus')) {
                            input.value = currentValue + 1;
                        } else if (clicked.classList.contains('minus') && currentValue > 0) {
                            input.value = currentValue - 1;
                        }

                        _this.updateItem(input.getAttribute('data-proid'), input.value);
                    }
                }
                var directAddEl = clicked.closest('[data-directadd]');
                if (directAddEl && directAddEl.getAttribute('data-directadd')) {
                    e.preventDefault();
                    var qtyRaw = directAddEl.getAttribute('data-directqty');
                    var qty = qtyRaw ? parseInt(qtyRaw, 10) : 1;
                    if (isNaN(qty) || qty < 1) {
                        qty = 1;
                    }
                    _this.addItem(directAddEl.getAttribute('data-directadd'), qty);
                }

                let isProcessing = false;

                if (clicked.closest("[data-protection-id]")) {
                    if (isProcessing) return; // stop second run
                    isProcessing = true;
                    setTimeout(() => isProcessing = false, 1000); // reset after 300ms

                    const clickedPro = clicked.closest("[data-protection-id]");
                    e.preventDefault();
                    const protectionId = clickedPro.getAttribute("data-protection-id");

                    if (clickedPro.classList.contains("active")) {
                        (document.querySelector("[data-sp-update]")?.removeAttribute("data-sp-update"));
                        sessionStorage.setItem(shipPs, "false");
                        clickedPro.classList.remove("active");
                        // _this.updateItemShort(protectionId, 0);
                    } else {
                        sessionStorage.setItem(shipPs, "true");
                        clickedPro.classList.add("active");
                        // _this.updateItemShort(protectionId,1);
                    }
                    _this.updateShippingProection();
                }

                if (clicked.classList.contains('swap-gift-wrap')) {
                    e.preventDefault();
                    document.querySelector('.gift-wrap-box')?.classList.toggle('active');
                }
                // pay buttons
                if (clicked.classList.contains('openpays')) {
                    e.preventDefault();
                    e.stopPropagation();
                    document.querySelector('#mini-cart')?.classList.toggle('quickpay');
                }
                //gift wrap
                if (clicked.closest("[ data-gift-wrap-id]"))
                    {
                        const clickedPro = clicked.closest("[data-gift-wrap-id]");
                        e.preventDefault();
                        const protectionId = clickedPro.getAttribute("data-gift-wrap-id");
                        if (clickedPro.classList.contains("active")) {
                            _this.updateItem(protectionId, 0);
                        } else {
                            // _this.addItem(protectionId);
                            document.querySelector('.gift-wrap-box').classList.add('active');
                        }
                    }
                    if (clicked.closest("[data-gift-wrap-change]"))
                    {
                        const clickedPro = clicked.closest("[data-gift-wrap-change]");
                        e.preventDefault();
                        const protectionId = clickedPro.getAttribute("data-gift-wrap-change");
                        if (clickedPro.classList.contains("active")) {
                            const giftWrapMessage = document.querySelector('.gift-wrap-message')?.value?.trim();
                            const cartData = {
                                id: protectionId,
                                quantity: 1
                            };

                            if (giftWrapMessage) {
                                cartData.properties = {
                                    Message: giftWrapMessage
                                };
                            } else {
                                cartData.properties = {
                                    Message:null
                                };
                            }

                            document.getElementById('mini-cart').classList.add('loading');

                            fetch('/cart/change.js', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify(cartData)
                            })
                                .then((response) => {
                                    if (!response.ok) throw new Error('Network response was not ok');
                                    return response.json();
                                })
                                .then(() => {
                                    _this.updateCart();
                                })
                                .catch(() => {
                                    _this.updateCart();
                                });
                        } else {
                            const giftWrapMessage = document.querySelector('.gift-wrap-message')?.value?.trim();
                            const cartData = {
                                id: protectionId,
                                quantity: 1
                            };

                            if (giftWrapMessage) {
                                cartData.properties = {
                                    Message: giftWrapMessage
                                };
                            } else {
                                cartData.properties = {
                                    Message: ""
                                };
                            }

                            document.getElementById('mini-cart').classList.add('loading');

                            fetch('/cart/add.js', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify(cartData)
                            })
                                .then((response) => {
                                    if (!response.ok) throw new Error('Network response was not ok');
                                    return response.json();
                                })
                                .then(() => {
                                    _this.updateCart();
                                })
                                .catch(() => {
                                    _this.updateCart();
                                });
                        }
                    }




            });
        });

        document.body.addEventListener('change', function (e) {
            let input = e.target;
            //change input in minicart items
            if (input.matches('.mcart-item [data-proid].qty-input')) {
                e.preventDefault();
                _this.updateItem(input.getAttribute('data-proid'), input.value);
            }

            if (input.matches(`[data-select-add]`)) {
                e.preventDefault();
                let variantId = input.value;
                if (!variantId) return;

                document.getElementById('mini-cart').classList.add('loading');

                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: variantId, quantity: 1 })
                })
                    .then(res => res.json())
                    .then(() => _this.updateCart())
                    .catch(() => alert("Failed to add item."));
            }
        });

        // Character counter for gift wrap message
        document.body.addEventListener('input', function(e) {
            if (e.target.classList.contains('gift-wrap-message')) {
                var textarea = e.target;
                var counter = textarea.closest('.gift-wrap-box')?.querySelector('.gift-wrap-counter');
                if (counter) {
                    var len = textarea.value.length;
                    var max = textarea.getAttribute('maxlength') || 200;
                    counter.textContent = len + '/' + max + ' characters';
                }
            }
        });


    },
    opencart: function () {

        document.querySelectorAll('body,html').forEach(item => {
            item.classList.add('mini-cart');
            setTimeout(function(){
                item.classList.add('mini-cart-ani');
            },500);
        });

    },
    closecart: function () {

        document.querySelectorAll('body,html').forEach(item => {
            item.classList.remove('mini-cart');
            setTimeout(function(){
                item.classList.remove('mini-cart-ani');
            },500);
        });

    },
    updateCart: function () {
        var _this = this;
        document.querySelectorAll('body, html').forEach(item => {
            item.classList.remove('mini-cart-ani');
        });

        fetch("/?sections=mini-cart")
            .then((response) => response.json())
            .then((data) => {

                 document.querySelector('#mini-cart .ajax_place').innerHTML = data['mini-cart'];


                // Update the main ajax_place content
                // document.querySelector('#mini-cart .ajax_place').innerHTML = data;


                 var countElement = document.querySelector('[data-icount]');
                 var counti = countElement ? parseInt(countElement.getAttribute('data-icount'), 10) : 0;
                 document.querySelectorAll('.cart-count-bubble').forEach(function (cartBubble) {
                     cartBubble.textContent = counti > 0 ? String(counti) : '';
                 });

            })
            .then(function () {
                // Call the animateCart function
                _this.animateCart();
                _this.updateShippingProection();
                _this.opencart();
                // Remove the loading class
                document.getElementById('mini-cart').classList.remove('loading');

                // Add the mini-cart-ani class to the body
                document.body.classList.add('mini-cart-ani');
                document.documentElement.classList.add('mini-cart-ani');
            })
            .catch(function (error) {
                console.error('Error fetching cart:', error);
            });



    }, animateCart: function () {
        // to update and animate mini cart with total price
        var _this = this;

         // Start of Selection
         document.querySelectorAll('.ns-target-gift').forEach(function(element) {
             document.querySelector('.target-gifts')?.appendChild(element);
         });


        var locks = document.querySelectorAll('.target-locks .target');
        var rate = window.market_exchange_rate ?? 1;
        var progess_bar_val = document.querySelector('.ns-progress')?.dataset.progress;// total price
        var gifts = document.querySelectorAll('.ns-target-gift');

        var current_target;
        var next_target;
        var current_progress = Number(progess_bar_val || 0);
        var gapToNext = 0;
        var gapToNextText = "";
        // change lock prices
        locks.forEach((target, i) => {
            const targetValue = target.getAttribute('data-target');
            const targetAmmount = targetValue * rate;
            const targetProgress = Number(target.getAttribute('data-progress') ?? progess_bar_val ?? 0);
            const targetAmmountRound = Math.round(targetAmmount / 100);

            if (targetValue) {
                const mclockPriceElem = target.querySelector('.mclock-price');
                if (mclockPriceElem) {
                    mclockPriceElem.textContent = targetAmmountRound;

                    if ((targetProgress < targetAmmount) && gapToNext<=0) {
                        current_target = target;
                        next_target = locks[i + 1];
                        current_progress = targetProgress;
                        gapToNext = targetAmmount - targetProgress;
                        gapToNextText = target.getAttribute('data-text');
                    }
                }

            }
        });

        // update cart quntity bar
        var mCartQty = document.querySelector('.m-cart-qty');
        if (gapToNext > 0) {
            var gapValue = (gapToNext / 100).toFixed(2);
            if (mCartQty)
            {
                mCartQty.textContent  = " : You are "+market_symbol+gapValue+" away from "+gapToNextText;
            }
            } else {
            if (mCartQty)  mCartQty.textContent  = "";
            }

        gifts.forEach(target => {

            const targetValue = target.getAttribute('data-gift-target');
            const targetAmmount = targetValue * rate;
            const giftProgressValue = Number(target.getAttribute('data-gift-progress') ?? progess_bar_val);
            const targetAmmountRound = Math.ceil((targetAmmount-giftProgressValue) / 100);


            const mclockPriceElem = target.querySelector('.giftgap');
            if (mclockPriceElem) mclockPriceElem.textContent = market_symbol+targetAmmountRound;

            if(giftProgressValue >= targetAmmount)
            {
                target.classList.add('mc-toadd-p');
            }else
            {
                target.classList.add('mc-notmet-p');
            }

            if (giftProgressValue >= targetAmmount && target.classList.contains('giftfalse') && target.classList.contains('noappgift') && !target.classList.contains('manualgift')) {
                _this.addItem(target.getAttribute('data-gift-id'));
                return;
            } else if (giftProgressValue < targetAmmount && target.classList.contains('gifttrue') && target.classList.contains('noappgift')) {
                _this.updateItem(target.getAttribute('data-gift-id'),0);
                return;
            }else if (target.classList.contains('multigift'))
            {
                _this.updateItem(target.getAttribute('data-gift-id'),1);
                return;
            }

        });

        var gap = 100 / (locks.length - 1);

        var last_target = locks[locks.length - 1];
        locks.forEach((target, i) => {
            const targetValue = target.getAttribute('data-target');
            const targetProgress = Number(target.getAttribute('data-progress') ?? progess_bar_val ?? 0);
            if (targetProgress >= (targetValue * rate)) {
                current_target = target;
                next_target = locks[i + 1];
                current_progress = targetProgress;

                setTimeout(function() {
                    target.classList.add("active");
                }, 300 * i);
            }
        });


        if (locks.length <= 2) {
            // document.querySelector('.mini-cart .top-wrap').style.display = 'none';
            let twr = document.querySelector('.mini-cart .top-wrap');
            if (twr) twr.style.display = 'none';
        }



        if (next_target) { // If next_target exists
            const currentTargetValue = parseFloat(current_target.getAttribute('data-target')) * rate;
            const nextTargetValue = parseFloat(next_target.getAttribute('data-target')) * rate;
            const extraval = (current_progress - currentTargetValue) / (nextTargetValue - currentTargetValue);
            const barwidth = (Array.from(locks).indexOf(current_target) * gap) + (gap * extraval);
            setTimeout(function(){
                document.querySelector('.ns-progress-fill').style.width = barwidth + "%";
                document.querySelector('.ns-progress-fill')?.style.setProperty('width', barwidth + '%');
            },100);
        } else {
            setTimeout(function(){
                document.querySelector('.ns-progress-fill')?.style.setProperty('width', '100%');
            },100);
        }


    },  reloadOfferbar:function () {
        var rate = typeof market_exchange_rate !== 'undefined' ? market_exchange_rate : 1;
        var targets = document.querySelectorAll('[data-target]');

        targets.forEach(function(target) {
            var val = target.getAttribute('data-target');
            if (target.querySelector('sp')) {
                target.querySelector('sp').textContent = Math.round(val * rate / 100);
            }
        });
    },
    updateShippingProection: function () {
        var shipOn = sessionStorage.getItem(shipPs);
        var orderTotal = document.querySelector('[data-total]')?.getAttribute('data-total');

        var total = parseFloat(orderTotal || "0");
        var foundId = null;

        // shipProtVars and market_exchange_rate must be defined globally
        // Use global variables directly (not window.)
        if (Array.isArray(shipProtVars) && typeof market_exchange_rate !== "undefined" && !isNaN(total)) {
            for (var i = 0; i < shipProtVars.length; i++) {
                var variantId = shipProtVars[i][0];
                var price = parseFloat(shipProtVars[i][1]);
                var convertedPrice = price * market_exchange_rate;

                if (total < convertedPrice) {
                    foundId = variantId;
                    shipLocalPrice = shipProtVars[i][2];
                    break;
                }
            }
        }
        var priceSpElem = document.querySelector('.shipping-protection .price-sp');
        if (priceSpElem && typeof shipLocalPrice !== 'undefined' && shipLocalPrice !== null && shipLocalPrice !== '') {
            // Add a space before appending, if not already present
            priceSpElem.textContent = shipLocalPrice;
        }

    // Shipping protection UI ([data-sp-all]) only renders when the cart has
    // merchandise. Without that guard, empty-cart page loads treated a missing
    // node as "no protection" and POSTed /cart/update.js — inflating ATC rate.
    var spAllElem = document.querySelector("[data-sp-all]");
    var spAllAttr = spAllElem ? spAllElem.getAttribute("data-sp-all") : "";
    var spAllArr = (spAllAttr || "").split(",").filter(Boolean);

    // Cart contains only shipping protection — remove it
    var onlyShippingElem = document.querySelector("[data-only-shipping-protection]");
    if (onlyShippingElem) {
        var protIdElem = document.querySelector("[data-protection-id]");
        if (protIdElem) {
            var protId = protIdElem.getAttribute("data-protection-id");
            if (protId) {
                var removeProtStr = "updates[" + protId + "]=0";
                fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: removeProtStr
                })
                .then(function(response) {
                    if (!response.ok) throw new Error('Network response was not ok');
                    return response.json();
                })
                .then(() => {
                    PROJ.ajaxcart.updateCart();
                })
                .catch(() => {
                    PROJ.ajaxcart.updateCart();
                });
                return;
            }
        }
    }

    // No merchandise cart / SP UI not present — do not add or mutate
    if (!spAllElem) {
        return;
    }

    // When automatic protection is disabled, only an explicit customer opt-in
    // may add or retain it. Missing/stale session state must default to off.
    if (shipOn === "false" || (shipProdAuto === false && shipOn !== "true")) {
        if (spAllArr.length > 0) {
            var removeStr = spAllArr.map(function(id) {
                return "updates[" + id + "]=0";
            }).join("&");
            if (removeStr) {
                fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: removeStr
                })
                .then(function(response) {
                    if (!response.ok) throw new Error('Network response was not ok');
                    return response.json();
                })
                .then(() => {
                    PROJ.ajaxcart.updatePriceCart();
                })
                .catch(() => {
                    PROJ.ajaxcart.updatePriceCart();
                });
            }
        }
        return;
    }

    // Already on the correct protection tier for this cart total
    if (spAllArr.length === 1 && spAllArr[0] === String(foundId)) {
        return;
    }

    // Auto-add (spauto) or swap tier when cart has merchandise and preference is on
    if ((spAllArr.length === 1 && spAllArr[0] !== String(foundId)) || spAllArr.length === 0) {
        var updateStr = "";
        if (spAllArr.length === 1 && spAllArr[0]) {
            updateStr = "updates[" + spAllArr[0] + "]=0";
            if (foundId) {
                updateStr += "&updates[" + foundId + "]=1";
            }
        } else if (foundId) {
            updateStr = "updates[" + foundId + "]=1";
        }

        if (updateStr) {
            fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: updateStr
            })
            .then(function(response) {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.json();
            })
            .then(() => {
                PROJ.ajaxcart.updatePriceCart();
            })
            .catch(() => {
                PROJ.ajaxcart.updatePriceCart();
            });
        }
    }
    },

    updatePriceCart:function () {
    fetch("/cart?view=mini")
        .then(function(response) {
            return response.text();
        })
        .then(function(data) {
            // Create a temporary div to parse the new HTML
            var tempDiv = document.createElement('div');
            tempDiv.innerHTML = data;

            // Find the new .mcart-footer.mc-ajax content
            var newFooter = tempDiv.querySelector('.mcart-footer.mc-ajax');
            var currentFooter = document.querySelector('.mcart-footer.mc-ajax');

            if (newFooter && currentFooter) {
                currentFooter.innerHTML = newFooter.innerHTML;
            }

            var counti = parseInt(tempDiv.querySelector('[data-icount]')?.getAttribute('data-icount') || '0', 10);
            document.querySelectorAll('.cart-count-bubble').forEach(function (cartBubble) {
                cartBubble.textContent = counti > 0 ? String(counti) : '';
            });
            if (document.querySelector('.c-header__cart-count')) {
                document.querySelector('.c-header__cart-count').textContent = counti > 0 ? String(counti) : '';
            }
            // Add shipLocalPrice to .shipping-protection .price-sp if available
            var priceSpElem = document.querySelector('.shipping-protection .price-sp');
            if (priceSpElem && typeof shipLocalPrice !== 'undefined' && shipLocalPrice !== null && shipLocalPrice !== '') {
                // Add a space before appending, if not already present
                priceSpElem.textContent = shipLocalPrice;
            }
        })
        .catch(function(error) {
            console.error('Error updating mini cart footer:', error);
        });
    },

    updateItem: function (id, le) {
        var _this = this;
        document.getElementById('mini-cart').classList.add('loading');
        fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: `quantity=${le}&id=${id}`,
        })
            .then((response) => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.json();
            })
            .then(() => {
                _this.updateCart();
            })
            .catch(() => {
                _this.updateCart();
            });
    },

    addItem: function (id, qty) {
        var _this = this;
        var quantity = qty != null ? parseInt(qty, 10) : 1;
        if (isNaN(quantity) || quantity < 1) {
            quantity = 1;
        }
        document.getElementById('mini-cart').classList.add('loading');
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: `quantity=${quantity}&id=${id}`,
        })
            .then((response) => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.json();
            })
            .then(() => {
                _this.updateCart();
            })
            .catch(() => {
                _this.updateCart();
            });
    }
};
